import React from 'react'
import { connect } from 'react-redux'
import agent from '../agent'
import numberHelper from '../util/numberFormatter'
import chartHelper from '../util/chartFormatter'
import ListErrors from './widgets/ListErrors'
import { Link } from 'react-router-dom'
import Util from '../util/util'
import { store } from "../store"
import { push } from "react-router-redux"
import Phone from 'react-phone-number-input'
import 'react-phone-number-input/style.css'
import { Translation } from 'react-i18next'
import i18n from '../languages/lang.js'

import {
  REGISTER,
  REGISTER_PAGE_UNLOADED,
  REDIRECT,
  VERIFY_USER_INFO
} from '../constants/actionTypes'
import { REACT_APP_BASE_COIN_SYMBOL, REACT_APP_REGISTRATION_REQUIRE_PHONE_VERIFICATION } from '../constants/config'
const mapStateToProps = state => ({
  ...state.auth,
  configs: state.common.configs,
  inProgress: state.common.inProgress
})

const mapDispatchToProps = dispatch => ({
  onSubmit: (payload) =>
    dispatch({ type: REGISTER, payload }),
  onRedirect: () =>
    dispatch({ type: REDIRECT }),
  onUnload: () => dispatch({ type: REGISTER_PAGE_UNLOADED }),
  onVerifyUserInfo: (payload, userInfo) =>
    dispatch({ type: VERIFY_USER_INFO, payload, userInfo }),
})

class Register extends React.Component {
  constructor() {
    super()
    this.state = {
      firstname: '',
      lastname: '',
      email: '',
      phone: '',
      password: '',
      referrer: '',
      validErrors: null
    }
    this.updateState = field => ev => {
      const state = this.state
      const newState = Object.assign({}, state, { [field]: ev.target.value })
      this.setState(newState)
    }
    this.validate = (firstname, lastname, phone, email, password) => {
      let errors = {}
      if (!firstname) {
        errors.firstname = { message: 'First name is required' }
      }
      if (!lastname) {
        errors.lastname = { message: 'Last name is required' }
      }
      if (!email) {
        errors.email = { message: 'Email is required' }
      } else {
        const emailReg = new RegExp('^([a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,6})$')
        if (!emailReg.test(email)) {
          errors.email = { message: 'Please input a valid email address' }
        }
      }
      if (!password) {
        errors.password = { message: 'Password is required' }
      } else {
        const pwdReg = new RegExp('^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[^\w\s]).{8,}$')
        if (!pwdReg.test(password)) {
          errors.password = { message: 'Password must be at least 8 characters long and containing one number, one lowercase letter, one capital letter and one special character' }
        }
      }

      return errors
    }
    this.submitForm = (firstname, lastname, phone, email, password, referrer) => ev => {
      ev.preventDefault()
      const validErrors = this.validate(firstname, lastname, phone, email, password)
      if (Object.keys(validErrors).length !== 0) {
        this.setState({ validErrors })
        return
      }
      const type = 'normal'
      const payload = agent.Auth.register(firstname, lastname, phone, email, password, referrer, '', type)
      this.props.onSubmit(payload)
    }
    this.verifyPhone = (firstname, lastname, phone, email, password, referrer) => ev => {
      ev.preventDefault()
      this.setState({ validErrors: null })
      const validErrors = this.validate(firstname, lastname, phone, email, password)
      if (Object.keys(validErrors).length !== 0) {
        this.setState({ validErrors })
        return
      }
      const type = 'normal'
      const userInfo = {
        firstname: firstname,
        lastname: lastname,
        phone: phone,
        email: email,
        password: password,
        referrer: referrer,
        type
      }
      const payload = agent.Auth.verifyUserInfo(firstname, lastname, phone, email, password, referrer)
      this.props.onVerifyUserInfo(payload, userInfo)
    }
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.verified) {
      store.dispatch(
        push("/register/verifyphone", {
          userInfo: nextProps.userInfo
        })
      )
    }
  }
  componentWillMount() {
    let search = this.props.location.search
    if (search) {
      let args = Util.getQueryStringArgs(search.toLowerCase())
      let referrer = args.referrer ? args.referrer.toUpperCase() : ''
      this.setState({ referrer: referrer })
    }
  }

  componentWillUnmount() {
    this.props.onUnload()
  }

  render() {
    const firstname = this.state.firstname || ""
    const lastname = this.state.lastname || ""
    const phone = this.state.phone || ""
    const email = this.state.email || ""
    const password = this.state.password || ""
    const referrer = this.state.referrer || ""
    const inProgress = this.props.inProgress
    const require_phone_verification = this.props.configs.require_phone_verification || REACT_APP_REGISTRATION_REQUIRE_PHONE_VERIFICATION
    const validErrors = this.state.validErrors
    return (
      <Translation>
        {
          (t) => (
            <div id="focus">
              <div id="focus-header"><h1>{t('system.name')}</h1></div>
              <div className="main">
                <div className="main-wrap">
                  <div className="focus-wrap">
                    <div className='box-header'>
                      <h2>{t('authentication.register_title')}</h2>
                    </div>
                    <div className="form-item">
                      <label>{t('input_label.firstname')}</label>
                      <input type="text" placeholder="John" value={firstname} onChange={this.updateState('firstname')} />
                    </div>
                    <div className="form-item">
                      <label>{t('input_label.lastname')}</label>
                      <input type="text" placeholder="Smith" value={lastname} onChange={this.updateState('lastname')} />
                    </div>
                    <div className="form-item">
                      <label>{t('input_label.phone')}</label>
                      <Phone country="AU" placeholder={'411001001'} displayInitialValueAsLocalNumber={false}
                        value={phone} onChange={phone => this.setState({ phone })}
                      />
                    </div>
                    <div className="form-item">
                      <label>{t('input_label.email')}</label>
                      <input type="text" placeholder="john@mit.edu" value={email} onChange={this.updateState('email')} />
                    </div>
                    <div className="form-item">
                      <label>{t('input_label.password')}</label>
                      <input type="password" value={password} onChange={this.updateState('password')} />
                    </div>
                    <ListErrors errors={validErrors ? validErrors : this.props.errors} />
                    <div className="form-item">
                      {
                        require_phone_verification ?
                          <button onClick={this.verifyPhone(firstname, lastname, phone, email, password, referrer)}>{t('authentication.register_next')}</button>
                          :
                          <button onClick={this.submitForm(firstname, lastname, phone, email, password, referrer)}>{this.props.inProgress ? t('authentication.register_button_progress') : t('authentication.register_complete_button')}</button>
                      }
                    </div>
                    <div className="form-item">
                      <Link to="/login" className='AuthPrompt'> <em>{t('authentication.login_prompt')}</em></Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )
        }
      </Translation >
    )
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Register)
